import { useIsAuthorized } from '@modules/common/components/CanAccess/hooks';
import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { InviteUsersByEmail } from '@modules/users/components/InviteUsersModal/InviteUsersByEmail';
import { UnderstandUserRolesButton } from '@modules/users/components/UnderstandUserRolesButton';
import { useFetchUsers } from '@modules/users/hooks';
import {
  Box,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { InviteUsersByLink } from './InviteUsersByLink';

interface InviteUsersModalProps {
  title?: string;
  description?: string;
  shouldFetchUsers?: boolean;
  shouldInviteAdminsOnly?: boolean;
}

export const InviteUsersModal = ({
  title = '🧑‍💻 Invite coworkers to join Enterpret!',
  description = 'Supercharge your team collaboration by inviting your coworkers onboard in just a click!',
  shouldFetchUsers = true,
  shouldInviteAdminsOnly = false,
}: InviteUsersModalProps) => {
  useFetchUsers({ skip: !shouldFetchUsers });

  const canAccessWorkspaceSettings = useIsAuthorized({
    resource: PermissionResource.WorkspaceSettings,
    operation: PermissionOperation.Write,
  });

  return (
    <>
      <ModalHeader title={title} />
      <Divider light />
      <DialogContent sx={{ px: 0 }}>
        <Stack spacing={3} pb={2} pt={0.5}>
          {description && (
            <Box px={2.5}>
              <Typography variant="subtitle1">{description}</Typography>
            </Box>
          )}
          <Box pt={1} px={2.5}>
            <InviteUsersByEmail
              shouldInviteAdminsOnly={shouldInviteAdminsOnly}
            />
          </Box>
          <Divider />
          <Box px={2.5}>
            <InviteUsersByLink
              shouldInviteAdminsOnly={shouldInviteAdminsOnly}
            />
          </Box>
        </Stack>
      </DialogContent>
      {canAccessWorkspaceSettings && !shouldInviteAdminsOnly && (
        <>
          <Divider light />
          <DialogActions sx={{ my: 1, mx: 2, justifyContent: 'flex-start' }}>
            <UnderstandUserRolesButton />
          </DialogActions>
        </>
      )}
    </>
  );
};
